import styles from "./FilterCard.module.css"
import CheckBox from "../../../CheckBox/CheckBox";
import { tagOption } from "../../../../types/tag";
/**
 * Props for the FilterOptionCard component.
*/ 
interface FilterOptionCardProps {
    value: tagOption, // Filter card value
    checked: boolean, // Whether the card is checked
    onToggle: ()=>void // Toggle event handler
}
/**
* A filter option card component that can be toggled on or off.
*
* @param props FilterOptionCard props
* @param {tagOption} props.value - Filter card value
* @param {boolean} props.checked - Whether the card is checked
* @param {() => void} props.onToggle - Toggle event handler
* @returns TSX.Element
*/
const FilterOptionCard = ({value, onToggle, checked} : FilterOptionCardProps) => {
    return (
        <>
            <div className={styles.FilterCard}>
                <p>{value.text}</p>
                <CheckBox isCircle={true} onCheck={onToggle} checked={checked} />
            </div>
        </>
    )
}
export default FilterOptionCard;
